import { render, staticRenderFns } from "./mechPage.vue?vue&type=template&id=09a395d1&scoped=true"
import script from "./mechPage.vue?vue&type=script&lang=js"
export * from "./mechPage.vue?vue&type=script&lang=js"
import style0 from "./mechPage.vue?vue&type=style&index=0&id=09a395d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a395d1",
  null
  
)

export default component.exports